<template>
  <div class="cmp cmp-student-card-3">
    <div class="content-wrapper">
      <div class="card-top">
        <img class="student-photo" :src="userAvatarDict[data.headPhoto]">
        <div class="student-name">{{data.studentName}}</div>
        <div class="evaluates-list">
          <div class="evaluates-item text-center" v-for="(v,i) in evaluatesList" :key="i">
            <el-tag :type="v.value===-1?'danger':'primary'">{{(data[v] || {}).title}}</el-tag>
            <p :class="v.value===-1?'text-danger':''">{{(data[v] || {}).content}}</p>
          </div>
        </div>
      </div>
      <div class="card-bottom">
        <div class="label">总体评价：</div>
        <x-star-bar type="warning" :size="24" fill
          :index="data.teacherStar || 0"
          @click="clickStarHandler"
        ></x-star-bar>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import publicUrl from '@/assets/js/interface'
// import utils from '@/assets/js/utils.js'

export default {
  name: 'cmp-student-card-3',
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      evaluatesList: [
        'quizRecord',
        'questionnaire',
        'topic',
        'groupChat',
        'workRecord',
      ],
      starRating: -1,
      loadingCount: 0
    }
  },
  computed: {
    ...mapState(['userAvatarDict']),
    ...mapGetters({
      classActive: 'classmanagement/classActive',
    }),
  },
  methods: {
    clickStarHandler (index) {
      this.starRating = index || 0
      this.taskEvaluateUpdate()
    },
    taskEvaluateUpdate () {
      this.loadingCount++
      let params = {
        classId: this.classActive.id,
        projectId: this.$route.query.projectId,
        // taskId: this.$route.query.taskId,
        taskId: this.data.taskId,
        taskName: this.data.taskName,
        studentId: this.data.studentId,
        // source: this.data.source,
        starRating: this.starRating,
      }
      this.$ajaxJson.post(publicUrl.taskEvaluateUpdate, params).then(res => {
        if (res.data.code === 0) {
          this.$emit('update', params)
          this.$message.success('保存成功' || res.data.message)
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$ajaxError(err)
      }).finally(() => {
        this.loadingCount--
      })
    }
  }
}
</script>

<style lang="less" scoped>
.cmp-student-card-3 {
  padding-top: 65px;
  margin: 10px auto;
  .content-wrapper {
    width: 368px;
    border-radius: 6px;
    box-shadow: 0px 4px 8px 0px rgba(134, 144, 167, 0.3);
  }
  .card-top {
    height: 222px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .student-photo {
      display: block;
      width: 126px;
      height: 126px;
      margin-top: -80px;
      border: 1px solid #CED2DA;
      border-radius: 50%;
      background-color: #fff;
    }
    .student-name {
      height: 28px;
      font-size: 20px;
      color: #464C5B;
      line-height: 28px;
    }
    .evaluates-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .evaluates-item {
        width: 96px;
        margin: 3px auto;
        p {
          font-size: .9em;
          line-height: 2;
        }
      }
    }
    .el-tag {
      margin: 0 10px;
      i {margin-right: .5em;}
    }
  }
  .card-bottom {
    height: 42px;
    padding: 5px 20px;
    background: #ECECEC;
    display: flex;
    .label {
      font-size: 20px;
      font-weight: 500;
      color: #464C5B;
      line-height: 32px;
    }
    .x-star-bar {
      width: 0;
      flex-grow: 1;
      height: 100%;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
  }
}
</style>
